const UNREAD_COUNT_SUCCESS_RESPONSE = {
    d: {
        unread_count: 2,
    },
};

export { UNREAD_COUNT_SUCCESS_RESPONSE };
